import { render, staticRenderFns } from "./tabsync.vue?vue&type=template&id=52b9bdc1&scoped=true"
import script from "./tabsync.vue?vue&type=script&lang=js"
export * from "./tabsync.vue?vue&type=script&lang=js"
import style0 from "./tabsync.vue?vue&type=style&index=0&id=52b9bdc1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b9bdc1",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ModalCartBase: require('/usr/src/app/components/modal/cart/Base.vue').default})
